module.exports = __webpack_public_path__ + "img/e545ab11eed41894f4b8ce287f8cee25.png";